import { render, staticRenderFns } from "./CmsIcon.vue?vue&type=template&id=05ee1196&"
import script from "./CmsIcon.vue?vue&type=script&lang=ts&"
export * from "./CmsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports